module.exports = __webpack_public_path__ + "static/img/home_icon_fzlc.837fb52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_icon_fzlc.png
// module id = YD1s
// module chunks = 2